<template>
    <div>
        <dx-grid
            url="foodDistributionFeedback"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="updateDialog" max-width="500">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Feedback</v-card-title
                >
                <v-layout row class="mt-3 mb-2">
                    <v-select
                        style="width: 50%"
                        class="mr-2"
                        label="Select Category"
                        :items="categories"
                        v-model="rowClicked.category"
                    ></v-select>
                    <v-text-field
                        style="width: 50%"
                        class=""
                        label="Type Category"
                        v-model="rowClicked.category"
                    ></v-text-field>
                </v-layout>
                <v-layout row class="mb-2">
                    <v-select
                        style="width: 50%"
                        class="mb-2 mr-2"
                        label="Select Status"
                        :items="statusList"
                        v-model="rowClicked.status"
                    ></v-select>
                    <v-text-field
                        style="width: 50%"
                        class="mb-2"
                        label="Type Status"
                        v-model="rowClicked.status"
                    ></v-text-field>
                </v-layout>
                <v-textarea
                    class="mb-2"
                    hide-details
                    label="Note"
                    v-model="rowClicked.note"
                    ref="note"
                    rows="4"
                    outline
                    font-weight-medium
                ></v-textarea>
                <div class="my-4 px-2 pt-2" style="border: solid 2px #4caf50;">
                    <v-layout row class="mt-2">
                        <v-select
                            class="mr-2"
                            outline
                            label="Email"
                            :items="emailList"
                            v-model="emailTo"
                            ref="emailTo"
                        ></v-select>
                        <v-text-field
                            style="width: 35%"
                            class="mr-2"
                            outline
                            label="Email"
                            :rules="[rules.email]"
                            v-model="emailTo"
                            ref="emailTo"
                        ></v-text-field>
                        <v-text-field
                            style="width: 35%"
                            class=""
                            label="CC"
                            ref="emailCC"
                            outline
                            :rules="[rules.email]"
                            v-model="emailCC"
                        ></v-text-field>
                    </v-layout>
                    <v-card-actions class="ma-0 mb-3 py-0">
                        <v-btn
                            :loading="sending"
                            class="text-xs-center mt-0"
                            color="success"
                            block
                            small
                            @click="sendEmail"
                        >
                            Send Email
                        </v-btn>
                    </v-card-actions>
                </div>
                <v-btn
                    small
                    color="success"
                    class="mt-0"
                    outline
                    @click="showEmailToCustomer = !showEmailToCustomer"
                    >Email To Customer</v-btn
                >
                <div
                    class="my-4 px-2 pt-2"
                    style="border: solid 2px #4caf50;"
                    v-if="showEmailToCustomer"
                >
                    <div class="font-weight-medium title">
                        Email To Customer
                    </div>
                    <v-layout row class="mt-2">
                        <v-text-field
                            style="width: 35%"
                            class="mr-2"
                            outline
                            label="From"
                            :rules="[rules.email]"
                            v-model="emailToCustomer.from"
                            ref="emailToCustomerFrom"
                        ></v-text-field>
                        <v-text-field
                            style="width: 35%"
                            class="mr-2"
                            outline
                            label="To"
                            :rules="[rules.email]"
                            v-model="emailToCustomer.to"
                            ref="emailToCustomerTo"
                        ></v-text-field>
                    </v-layout>
                    <v-textarea
                        class="mb-2"
                        hide-details
                        label="Message"
                        v-model="emailToCustomer.message"
                        ref="emailToCustomerToMessage"
                        rows="4"
                        outline
                    ></v-textarea>
                    <v-card-actions class="ma-0 mb-3 py-0">
                        <v-btn
                            :loading="sendingToCustomer"
                            class="text-xs-center mt-0"
                            color="success"
                            block
                            small
                            @click="sendEmailToCustomer"
                        >
                            Send Email
                        </v-btn>
                    </v-card-actions>
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeDialog()"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveFeedback(rowClicked)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div></template
>
<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Feedback",
        columns: [
            {
                label: "Account ID",
                field: "accountID",
                link: "FoodDistributionFamilyView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "NameH",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(7, "day")
                        .add(1, "day")
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Caller ID",
                field: "callerID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording",
                template: "link-audio-cell-template",
                field: "recording",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Category",
                field: "category",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Scan Time",
                field: "lastScan",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Scan Location",
                field: "lastScanLocation",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Delivery Address",
                field: "lastDeliveryAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Enrolled",
                field: "enrolled",
                visible: true,
                template: "link-action-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated By",
                field: "updatedBy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated At",
                field: "updatedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Students Count",
                field: "studentsCount",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        user: "",
        processing: false,
        rowClicked: "",
        updateDialog: false,
        showEmailToCustomer: false,
        categories: [],
        statusList: [],
        emailList: [],

        emailTo: "",
        emailCC: "",
        sending: false,
        sendingToCustomer: false,

        emailToCustomer: {
            from: "",
            to: "",
            message: "",
        },

        rules: {
            email: (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return !value || pattern.test(value) || "Invalid e-mail.";
            },
        },
    }),
    mounted() {},
    beforeDestroy() {},
    created() {
        this.user = this.$store.state.authentication.user;

        this.loadCategories();
        this.loadStatusList();

        const emails = localStorage.getItem("feedback-sent-to-emails");

        this.emailList = emails ? JSON.parse(emails) : [];
    },
    methods: {
        onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));

            this.rowClicked.date = moment(
                new Date(this.rowClicked.date)
            ).format("YYYY-MM-DD HH:mm:ss");
            this.rowClicked.lastScan = moment(
                new Date(this.rowClicked.lastScan)
            ).format("YYYY-MM-DD HH:mm:ss");

            this.emailToCustomer.to = this.rowClicked.emailAddress;
            this.emailToCustomer.from = this.$store.state.authentication.user;
            this.emailToCustomer.message = "";

            this.updateDialog = true;
        },
        closeDialog() {
            this.emailToCustomer.message = "";
            this.showEmailToCustomer = false;

            this.updateDialog = false;
        },
        async saveFeedback() {
            this.processing = true;

            try {
                await this.$http.post(
                    "api/foodDistributionFeedback/updateFeedback?",
                    {
                        id: this.rowClicked.id,
                        note: this.rowClicked.note,
                        status: this.rowClicked.status,
                        category: this.rowClicked.category,
                        user: this.user,
                    }
                );

                this.processing = false;
            } catch (e) {
                this.processing = false;

                return;
            }

            this.updateDialog = false;

            this.$refs.grid.reloadGrid();
        },
        async loadCategories() {
            const categories = await this.$http.get(
                "api/foodDistributionFeedback/getCategories"
            );

            this.categories = categories;
        },
        async loadStatusList() {
            const statusList = await this.$http.get(
                "api/foodDistributionFeedback/getStatusList"
            );

            this.statusList = statusList;
        },
        async sendEmail() {
            if (!this.$refs.emailTo.validate(true)) return;

            if (!this.emailTo) {
                this.$notify({
                    group: "notification",
                    text: "Missing Email",
                    type: "error",
                });

                return;
            }

            this.sending = true;

            try {
                await this.$http.post(
                    "api/foodDistributionFeedback/sendEmail",
                    {
                        emailTo: this.emailTo,
                        cc: this.emailCC,
                        feedback: this.rowClicked,
                    }
                );

                if (!this.emailList.includes(this.emailTo)) {
                    this.emailList.push(this.emailTo);
                }

                localStorage.setItem(
                    "feedback-sent-to-emails",
                    JSON.stringify(this.emailList)
                );

                this.$notify({
                    group: "notification",
                    text: "Email Sent",
                    type: "success",
                });

                this.sending = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.sending = false;

                return;
            }
        },
        async sendEmailToCustomer() {
            if (
                !this.$refs.emailToCustomerFrom.validate(true) ||
                !this.$refs.emailToCustomerTo.validate(true)
            )
                return;

            if (!this.emailToCustomer.from) {
                this.$notify({
                    group: "notification",
                    text: "Missing From Email",
                    type: "error",
                });

                return;
            }

            if (!this.emailToCustomer.to) {
                this.$notify({
                    group: "notification",
                    text: "Missing To Email",
                    type: "error",
                });

                return;
            }

            this.sendingToCustomer = true;

            try {
                await this.$http.post(
                    "api/foodDistributionFeedback/sendEmailToCustomer",
                    {
                        from: this.emailToCustomer.from,
                        to: this.emailToCustomer.to,
                        message: this.emailToCustomer.message,
                        feedback: this.rowClicked,
                    }
                );

                if (!this.emailList.includes(this.emailToCustomer.from)) {
                    this.emailList.push(this.emailToCustomer.from);
                }

                localStorage.setItem(
                    "feedback-sent-to-emails",
                    JSON.stringify(this.emailList)
                );

                this.$notify({
                    group: "notification",
                    text: "Email Sent To Customer",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();

                this.sendingToCustomer = false;
            } catch (e) {
                this.sendingToCustomer = false;

                return;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
</style>
